import { render, staticRenderFns } from "./OwnerSecurityDetails.vue?vue&type=template&id=b8b68364&"
import script from "./OwnerSecurityDetails.vue?vue&type=script&lang=js&"
export * from "./OwnerSecurityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports